import React from 'react';

import WrapperWidget from '../Wrapper';
import InputText from '../../../FormFields/Text';
import InputFile from '../../../FormFields/File';
import Checkbox from '../../../FormFields/Checkbox';
import withConditionsAndTriggers from '../withConditionsAndTriggers';

export class MultiplePhotoWidget extends React.PureComponent {
  renderConfigTab = (internalField, changeFieldValue, changeFieldError) => {
    return (
      <div className='Widget_Form_Config'>
        <InputText label='Label' required value={ api ?  api.getFieldsVerbiage(internalField, 'label') : internalField.label }
                   onChange={ (v) => changeFieldValue('label', v) } error={ internalField.errors['label'] }
                   onError={ (error) => changeFieldError('label', error) }/>
        <InputText label='Description' value={ api ?  api.getFieldsVerbiage(internalField, 'label') : internalField.label }
                   onChange={ (v) => changeFieldValue('description', v) }/>
        <div className='InputCheckboxesWrapper'>
          <Checkbox onChange={ (v) => changeFieldValue('labelInline', v) } label='Label inline'
                    checked={ internalField.labelInline }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('required', v) } label='Required'
                    checked={ internalField.required }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('notes', v) } label='Notes'
                    checked={ internalField.notes }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('lockDDR', v) } label='Lock in DDR'
                    checked={ internalField.lockDDR }
                    className='InputCheckbox_Block'/>
        </div>
      </div>
    );
  };

  render() {
    const { field, renderForm, value, onChange, onError, error } = this.props;
    const props = {
      ...this.props,
      renderForm: () => renderForm(this.renderConfigTab),
      formTitle: 'Multiple Photo Input',
    };
    return (
      <WrapperWidget {...props}>
        <div className='MultiplePhotoWidget'>
          <InputFile
            disabled={ field.disabled }
            placeholder='Drag your photos here or click to upload'
            required={ field.required }
            multiple={ true }
            accept='image/*'
            value={ value }
            onChange={ onChange }
            onError={ onError }
            error={ error }
          />
        </div>
      </WrapperWidget>
    );
  }
}

export const MultiplePhotoWidgetEditable = withConditionsAndTriggers(MultiplePhotoWidget);
